import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment-timezone';
import { Observable } from 'rxjs';

import { CoachSettingsGeneralInformationController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-information/coach-settings-general-information.controller';
import { SelectItem } from 'primeng/api';

@Component({
	selector: 'spr-coach-settings-general-information',
	templateUrl: './coach-settings-general-information.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachSettingsGeneralInformationController],
	host: {
		class: 'h-full',
	},
})
export class CoachSettingsGeneralInformationComponent {
	public calendarLocale$: Observable<any>;
	public birthDateRange: string;
	public timeZones = moment.tz
		.names()
		.map((name) => ({ label: name, value: name } as SelectItem));

	@Input() public informationForm: FormGroup;

	constructor(private _controller: CoachSettingsGeneralInformationController) {
		const birthMaxYear = moment().subtract(16, 'year').year();
		const birthMinYear = moment().subtract(90, 'year').year();
		this.birthDateRange = `${birthMinYear}:${birthMaxYear}`;
		this.calendarLocale$ = _controller.calendarLocale$;
	}
}
